export const ENTRY_RULES_CLICKED = 'ENTRY_RULES_CLICKED';
